var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"not_found"}},[_c('img',{attrs:{"src":require("@/assets/404.png"),"alt":""}}),_c('div',[_c('h3',[_vm._v("抱歉，当前页面无法访问")]),_c('p',[_vm._v("网址错误或不存在。请检查您的网址是否正确")]),_c('div',{staticClass:"btn"},[_c('button',{on:{"click":function($event){return _vm.$router.replace('/')}}},[_vm._v("回到首页")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }